export default __webpack_public_path__ + "static/media/phone-verification-background-logged-out-mobile.0467cab4.png";